import { S_PageStyle } from 'pages/page/PageStyle';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const RedirectPage = (props: Props): JSX.Element => {
    const { id } = useParams() as { id: string };
    const navigate = useNavigate();

    useEffect(() => {
        if (id === 'olomouckyveletrh') {
            navigate('/event/martin', { replace: true });
        } else if (id === 'odf') {
            navigate('/map2/b1c9e939-6d3b-4025-b432-e5c9b78c0038', { replace: true });
        }
    }, [id]);

    return <S_RedirectPage className={props.className} />;
};

const S_RedirectPage = styled(S_PageStyle)``;
